import {
  ROUTE,
  ROUTE_PATH
} from 'modules/routes/constants/index.cjs'
import { MOTIVATION_DOMAIN } from 'modules/motivation/constants'
import { searchItemsSectionUtil } from 'modules/section/utils/search-items'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import loadSectionAction from 'modules/section/actions/load'
import { getSearchDomainListSectionSelector } from 'modules/section/selectors/getSearchDomainList/index.js'

function loadCommunityPostsProductActions (queryString) {
  return (dispatch, getState) => {
    const query = {
      exact: true,
      query: queryString,
      limit: 6
    }
    // Get the items that can match the query
    const domain = getState()[MOTIVATION_DOMAIN]
    const domainList = getSearchDomainListSectionSelector({
      section: SECTIONS_NAME.MOTIVATION
    })(getState())

    const items = searchItemsSectionUtil({
      domain,
      section: SECTIONS_NAME.MOTIVATION,
      domainList,
      query: queryString,
      isExact: true
    })

    // Enough items cached
    if (items.length >= 6) {
      return
    }

    // Force the loading
    const options = {
      isForced: true,
      query
    }
    return dispatch(
      loadSectionAction(ROUTE[ROUTE_PATH.MOTIVATION], {}, options)
    )
  }
}

export default loadCommunityPostsProductActions
